const KNOWLEDGE_BASE = [
  { terms: ["clam", "clams", "oyster", "oysters", "mussel", "mussels", "scallop", "scallops"], category: "Seafood", subCategory: "Shellfish" },
  { terms: ["shrimp", "prawn", "lobster", "crab", "crabmeat", "langostino"], category: "Seafood", subCategory: "Shellfish" },
  { terms: ["salmon", "tuna", "cod", "halibut", "tilapia", "snapper", "trout", "mahi", "flounder", "grouper", "haddock", "swordfish"], category: "Seafood", subCategory: "Finfish" },
  { terms: ["beef", "steak", "brisket", "burger", "ground beef", "ribeye", "sirloin"], category: "Meat", subCategory: "Beef" },
  { terms: ["chicken", "breast", "thigh", "wing", "drumstick", "tenderloin"], category: "Meat", subCategory: "Poultry" },
  { terms: ["pork", "bacon", "ham", "sausage", "prosciutto"], category: "Meat", subCategory: "Pork" },
  { terms: ["lettuce", "tomato", "tomatoes", "onion", "onions", "pepper", "peppers", "broccoli", "spinach", "kale", "carrot", "carrots", "celery", "cucumber", "avocado"], category: "Produce", subCategory: "Vegetables" },
  { terms: ["apple", "apples", "banana", "bananas", "berry", "berries", "orange", "oranges", "lemon", "lemons", "lime", "limes", "grape", "grapes", "melon"], category: "Produce", subCategory: "Fruit" },
  { terms: ["milk", "cheese", "cream", "yogurt", "butter"], category: "Dairy", subCategory: "Dairy" },
  { terms: ["bread", "bun", "roll", "bagel", "croissant", "muffin", "cookie", "cake", "brownie"], category: "Bakery", subCategory: "Baked Goods" },
  { terms: ["coffee", "tea", "juice", "soda", "water", "sparkling", "lemonade"], category: "Beverage", subCategory: "Non-Alcoholic" },
  { terms: ["wine", "beer", "vodka", "whiskey", "tequila", "rum", "gin"], category: "Alcohol", subCategory: "Alcohol" },
  { terms: ["rice", "pasta", "flour", "sugar", "salt", "spice", "seasoning", "oil", "vinegar", "beans", "lentils"], category: "Dry Goods", subCategory: "Pantry" },
  { terms: ["sauce", "ketchup", "mustard", "mayo", "mayonnaise", "aioli", "dressing", "marinade"], category: "Dry Goods", subCategory: "Condiments" },
  { terms: ["fries", "frozen", "ice cream", "sorbet"], category: "Frozen", subCategory: "Frozen" },
];

const normalize = (value) => String(value || '').toLowerCase().trim();

export function getInventoryCategorySuggestion(item = {}) {
  const haystack = [item?.name, item?.sku, item?.category, item?.subCategory]
    .map(normalize)
    .filter(Boolean)
    .join(' ');

  if (!haystack) return null;

  for (const rule of KNOWLEDGE_BASE) {
    const matchedTerm = rule.terms.find((term) => haystack.includes(normalize(term)));
    if (!matchedTerm) continue;

    const currentCategory = String(item?.category || '').trim() || 'Uncategorized';
    const currentSubCategory = String(item?.subCategory || '').trim() || '';
    const currentCombined = currentSubCategory ? `${currentCategory} / ${currentSubCategory}` : currentCategory;
    const recommendedCombined = rule.subCategory ? `${rule.category} / ${rule.subCategory}` : rule.category;
    const alreadyMatches = normalize(currentCombined) === normalize(recommendedCombined);

    return {
      itemId: item?.id || null,
      name: item?.name || 'Untitled Item',
      sku: item?.sku || '',
      matchedTerm,
      currentCategory,
      currentSubCategory,
      currentCombined,
      recommendedCategory: rule.category,
      recommendedSubCategory: rule.subCategory || null,
      recommendedCombined,
      alreadyMatches,
    };
  }

  return null;
}

export function buildInventoryCategorySuggestions(items = []) {
  return (Array.isArray(items) ? items : [])
    .map((item) => getInventoryCategorySuggestion(item))
    .filter(Boolean)
    .filter((suggestion) => !suggestion.alreadyMatches);
}
